import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container, Row, Tab, Nav, Col, Image, Button, Form, FloatingLabel, Alert, Accordion } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from "yup";
import PhoneInput from 'react-phone-input-2';
import { TailSpin, ThreeDots } from 'react-loader-spinner';
import { format } from 'date-fns';

import { ageService } from '../functions/ageApi';
import { authService } from '../functions/authenticate';
import { accountService } from '../functions/registerApi';
import { forgetPasswordService } from '../functions/forgotPassword';
import { profileService } from '../functions/profile';
import UpdatePasswordModal from '../components/updatePasswordModal';
import VerifyEmailModal from '../components/verifyEmailModal';
import UpdateRegistrationModal from '../components/updateRegistrationModal';
import NoticeModal from '../components/noticeModal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint, faPen, faMagnifyingGlass, faEdit } from "@fortawesome/free-solid-svg-icons";

import '../scss/Profile.scss';


const Profile = ({ login, setLogin, userID, setUserID, setUserName, authToken, setAuthToken, marathonName }) => {


    /***************************************************
     * Enable registration editing function
     ***************************************************/
    const [canEdit, setCanEdit] = useState(true);

    const navigate = useNavigate();
    const [authVerified, setAuthVerified] = useState(false);
    const countryList = require('../data/country.json');
    const [email, setEmail] = useState('');
    const [oldEmail, setOldEmail] = useState('');
    const [key, setKey] = useState('myRun');
    const { tab } = useParams();
    const [initialize, setInitialize] = useState(false);

    const [smShow, setSmShow] = useState(false);
    const [lgShow, setLgShow] = useState(false);


    /***********************************************
     * Email verification status
     * 0 - no need verification
     * 1 - need verification but not verified
     * 2 - need verification and verified
     * ********************************************/
    const [emailVerified, setEmailVerified] = useState(0);


    // success variable
    const [passwordMessage, setPasswordMessage] = useState('');
    const [verifyEmailMessage, setVerifyEmailMessage] = useState('');
    const [updateProfileMessage, setUpdateProfileMessage] = useState('');
    // error variables
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [passwordErr, setPasswordErr] = useState(false);
    const [passwordErrMessage, setPasswordErrMessage] = useState('');
    const [verifyEmailErr, setVerifyEmailErr] = useState(false);
    const [verifyEmailErrMessage, setVerifyEmailErrMessage] = useState('');
    const [updateProfileErrMessage, setUpdateProfileErrMessage] = useState('');

    // Loading variables
    const [verifyEmailLoading, setVerifyEmailLoading] = useState(false); // verify emaill loading trigger
    const [passwordLoading, setPasswordLoading] = useState(false); // reset password loading trigger
    const [updateProfilLoading, setUpdateProfilLoading] = useState(false); // update profil loading trigger
    const [myBib, setMyBib] = useState(false); // initialize my registration loading trigger

    // verify email modal trigger
    const [verifyEmailModal, setVerifyEmailModal] = useState(false);
    const handleVerifyEmailModalShow = () => {
        sendOTP();
        setVerifyEmailModal(true);
    };
    const handleVerifyEmailModalHide = () => {
        setVerifyEmailMessage('');
        setVerifyEmailErrMessage('');
        setVerifyEmailErr(false);
        setVerifyEmailModal(false);
    };
    // submit handling function
    const handleSubmitVerifyEmail = (value, index) => {
        // console.log(value);
        setVerifyEmailMessage('');
        setVerifyEmailErrMessage('');
        setVerifyEmailErr(false);
        setVerifyEmailLoading(true);

        forgetPasswordService.verifyOTP(userID, value)
            .then((response) => {
                // console.log(response);
                if (response.status) {
                    setVerifyEmailMessage('Email verified successfully');
                    handleVerifyEmailModalHide();
                    setEmailVerified(2);

                } else {
                    setVerifyEmailErrMessage('Ops... Something went wrong. Please try again later.');
                    setVerifyEmailErr(true);
                    setVerifyEmailLoading(false);
                }
            })
            .catch((err) => {
                // console.log(err);
                setVerifyEmailErrMessage('Ops... Something went wrong. Please try again later.');
                setVerifyEmailErr(true);
                setVerifyEmailLoading(false);
            });
    }

    // update password modal trigger
    const [updatePasswordModal, setUpdatePasswordModal] = useState(false);
    const handlePasswordModalShow = () => setUpdatePasswordModal(true);
    const handlePasswordModalHide = () => setUpdatePasswordModal(false);
    // submit handling methods
    const handleSubmitResetPassword = (values) => {
        setPasswordErr(false);
        setPasswordLoading(true);
        handlePasswordModalHide();

        forgetPasswordService.updatePassword(userID, values.currentPassword, values.newPassword, values.reenterPassword, authToken)
            .then((response) => {
                // console.log(response);

                if (response.status) {
                    setPasswordMessage('Your password has been updated successfully.');
                    setPasswordLoading(false);
                    // setTimeout(function() { navigate('/Login'); }, 5000);
                } else {
                    setPasswordErrMessage(response.body.message !== '' ? response.body.message : 'Update password failed. Please try again.');
                    setPasswordErr(true);
                    setPasswordLoading(false);
                }
            })
            .catch((err) => {
                console.log(err);
                setPasswordErrMessage('Update password failed. Please try again.');
                setPasswordErr(true);
                setPasswordLoading(false);
            });
    };


    /********************************************************
     * Update Registration Modal 
     *******************************************************/
    const [runnerID, setRunnerID] = useState('');
    const [updateRegistrationModal, setUpdateRegistrationModal] = useState(false);
    const handleRegistrationModalShow = (individualID) => {
        setRunnerID(individualID);
        setUpdateRegistrationModal(true);
    };
    const handleRegistrationModalHide = () => setUpdateRegistrationModal(false);


    /********************************************************
     * Registration 
     *******************************************************/
    const [runners, setRunners] = useState([]);
    const [paymentID, setPaymentID] = useState([]);
    const [paymentDate, setPaymentDate] = useState([]);

    useEffect(() => {
        const token = localStorage.getItem('authToken');
        if (token === '' || token === null) {
            navigate('/Login');
        }
        else {
            // console.log(token);
            authService.validateAuthToken(token)
                .then((response) => {
                    // console.log(response);
                    if (!response.status) {
                        setAuthVerified(true);
                        navigate('/Login');
                    }
                    else {
                        let data = response.body.user;
                        setUserID(data.individualID);
                        localStorage.setItem('userID', data.individualID);
                        // console.log(localStorage.getItem('userID'));
                        setLogin(true);

                        setUserName(data.firstname + ' ' + data.lastname);
                        localStorage.setItem('userName', data.firstname + ' ' + data.lastname);

                        setAuthToken(response.body.token);
                        localStorage.setItem('authToken', response.body.token);

                        setAuthVerified(true);

                    }
                })
                .catch((error) => {
                    console.log(error);
                    navigate('/Login');
                })
        }
    }, [authToken]);

    // initialize the react hook
    useEffect(() => {

        if (tab !== "" && tab !== null && tab !== undefined) {
            setKey(tab);
        } else {
            setKey('myRun');
        }

        let userId = localStorage.getItem('userID');

        accountService.getUser(userId)
            .then(response => {
                // console.log(response);
                if (response.status) {
                    const data = response.body.user;
                    const age = ageService.calculateAge(data.dob);

                    // console.log(data);

                    const obj = {
                        profileUrl: '',
                        individualID: data.individualID,
                        firstname: data.firstname !== null ? data.firstname : '',
                        lastname: data.lastname !== null ? data.lastname : '',
                        email: data.email !== null ? data.email : '',
                        contact: data.phone_no !== null ? data.phone_no : '',
                        mykad: data.mykad !== null ? data.mykad : '',
                        gender: data.gender !== null ? data.gender : '',
                        dob: data.dob !== null ? data.dob : '',
                        nationality: data.nationality !== null ? data.nationality : '',
                        contact: data.phone_no !== null ? data.phone_no : '',
                        city: data.city !== null ? data.city : '',
                        state: data.state !== null ? data.state : '',
                        address: data.address !== null ? data.address : '',
                        postcode: data.postcode !== null ? data.postcode : '',
                        country: data.country !== null ? data.country : ''
                    }

                    setProfileInfo(obj);

                    setUserID(data.individualID);
                    setEmail(data.email);
                    setOldEmail(data.email);
                }
                else {
                    const err = response.body;
                    setError(true);
                    setErrorMessage(err.message);
                }
            })
            .finally(() => {
                setInitialize(true);
            })
            .catch(err => console.error(err));


        // At this point, the current is defined. This if is useful in case you use TypeScript
        if (renderedRef.current) {
            setCardHeight(renderedRef.current.clientHeight);
        }

    }, []);


    useEffect(() => {

        setMyBib(false);
        setHasRun(false);

        if (userID !== null && userID !== "" && authVerified) {

            accountService.getRegistration(userID, authToken, process.env.REACT_APP_MARATHON_NAME)
                .then(response => {

                    // console.log(response);

                    if (response.status === true && response.hasData === true) {
                        const hasData = response.hasData;
                        const data = response.body.runner;

                        // console.log(data);

                        // if(hasData) {
                        const obj = {
                            bib_name: data.bib_name !== null ? data.bib_name : '-',
                            bib_no: data.bib_no !== null ? data.bib_no : 'Bib Number',
                            race_cat: data.race_cat !== null ? data.race_cat : '-',
                            race_cat_type: data.race_cat_type !== null ? data.race_cat_type : '-',
                            tshirt_type: data.tshirt_type !== null ? data.tshirt_type : 'T-shirt',
                            tshirt_size: data.tshirt_size !== null ? data.tshirt_size : '-',
                            finisher_size: data.finisher_size !== null ? data.finisher_size : '-',
                            emergency_name: data.emergency_name !== null ? data.emergency_name : '-',
                            emergency_contact: data.emergency_contact !== null ? data.emergency_contact : '-',
                            medical_attn: data.medical_attention !== null ? data.medical_attention : '-'
                        }

                        setRunner(obj);
                        setHasRun(true);

                        // } else {
                        //     setError(true);
                        //     // setErrorMessage(data.message);
                        // }

                        setMyBib(true);

                    }
                    else {
                        const err = response.body;
                        setError(true);
                        setErrorMessage(err.message);
                        setMyBib(true);
                    }
                })
                .catch(err => console.error(err));

            accountService.getAllRegistration(userID, authToken)
                .then(response => {

                    // console.log(response);

                    if (response.status === true && response.hasData === true) {
                        let newList = [];
                        let newArray = [];
                        let paymentID = '';
                        let paymentDate = '';

                        let dataArray = response.body.runner;
                        dataArray.map((runner, index) => {
                            if (paymentID !== runner.paymentID) {
                                if (index !== 0) {
                                    newList.push({
                                        paymentID: paymentID,
                                        datetime: paymentDate,
                                        runner: newArray
                                    });
                                }

                                paymentID = runner.paymentID;
                                var date = new Date(runner.datetime_posted);
                                paymentDate = format(date, "dd MMMM yyyy");
                                newArray = [];
                            }
                            newArray.push(runner);
                        });

                        if (paymentID.length !== 0) {
                            newList.push({
                                paymentID: paymentID,
                                date: paymentDate,
                                runner: newArray
                            });
                        }
                        // console.log(newList);
                        setRunners(newList);
                        setMyBib(true);

                    }
                    else {
                        const err = response.body;
                        setError(true);
                        setErrorMessage(err.message);
                        setMyBib(true);
                    }
                })
                .catch(err => console.error(err));
        }



    }, [initialize, authVerified]);

    /********************************************************
     * Dashboard Functions
     ********************************************************/
    const [flip, setFlip] = useState(false);
    const renderedRef = useRef();
    const [hasRun, setHasRun] = useState(false);
    const initialValuesRun = {
        bib_name: '',
        bib_no: '',
        race_cat: '',
        race_cat_type: '',
        gender: '',
        tshirt_size: '',
        finisher_size: '',
        emergency_name: '',
        emergency_contact: '',
        medical_attn: ''
    }
    const [runner, setRunner] = useState(initialValuesRun);
    const [cardHeight, setCardHeight] = useState(760);


    /********************************************************
     * Profile Functions
     ********************************************************/
    const initialValues1 = {
        profileUrl: '',
        individualID: '',
        firstname: '',
        lastname: '',
        email: '',
        contact: '',
        mykad: '',
        gender: '',
        dob: '',
        nationality: '',
        country: '',
        city: '',
        state: '',
        address: '',
        postcode: ''
    }
    const [profileInfo, setProfileInfo] = useState(initialValues1);
    const SignUpSchema1 = Yup.object().shape({
        firstname: Yup.string()
            .min(2, "Too Short!")
            .max(50, "Too Long!")
            .required("First name is required"),

        lastname: Yup.string()
            .min(2, "Too Short!")
            .max(50, "Too Long!")
            .required("Last name is required"),

        email: Yup.string()
            .email("Incorrect format")
            .required("Email is required"),

        contact: Yup.string()
            .required("Contact number is required"),

        // mykad: Yup.string()
        //     .required("Identity Card / Passport is required"),

        gender: Yup.string()
            .required("Gender is required"),

        dob: Yup.date()
            .max(new Date(), "Invalid date of birth, the date must be earlier than today")
            .required("Birth date is required"),

        nationality: Yup.string()
            .required("Nationality is required"),

        country: Yup.string()
            .required("Country is required"),

        city: Yup.string()
            .required("City is required"),

        state: Yup.string()
            .required("State is required"),

        address: Yup.string()
            .required("Address is required"),

        postcode: Yup.number()
            .required("Postcode is required"),

    });
    const submitForm1 = (values) => {
        setUpdateProfilLoading(true);

        // console.log(values);

        profileService.updateProfile(userID, values, authToken)
            .then(response => {
                // console.log(response);
                setUpdateProfileMessage('Updated successfully');
                setUpdateProfilLoading(false);
            })
            .catch(err => {
                console.log(err);
                setUpdateProfileErrMessage('Ops... Something went wrong. Please try again later.');
                setUpdateProfilLoading(false);
            });
    }



    /*********************************************************
     * Functions
     *********************************************************/
    const sendOTP = () => { // send new OTP
        setVerifyEmailMessage('');
        setVerifyEmailErrMessage('');
        setVerifyEmailErr(false);
        setVerifyEmailLoading(true);

        forgetPasswordService.resendOTP('', email)
            .then((response) => {
                // console.log(response);
                if (response.status) {
                    setVerifyEmailMessage('New OTP has been sent to your email successfully.');
                    setVerifyEmailLoading(false);
                } else {
                    setVerifyEmailLoading(false);
                    setVerifyEmailErrMessage('Ops... Something went wrong. Please try again.');
                    setVerifyEmailErr(true);
                }
            })
            .catch((err) => {
                console.log(err);
                setVerifyEmailErrMessage('Ops... Something went wrong. Please try again.');
                setVerifyEmailErr(true);
                setVerifyEmailLoading(false);
            });
    }

    const handleEmail = (e) => {
        if (oldEmail === e.target.value) {
            setEmailVerified(0);
        } else {
            setEmailVerified(1);
        }
    }

    const goRegister = (e) => {
        e.preventDefault();
        navigate('/Register');
    }

    const goEditRegistration = (e) => {
        e.preventDefault();
        navigate('/EditRegistration');
    }

    const registrationDetail = (paymentID) => {
        localStorage.setItem('isEdit', true);
        handleEditRegistration(paymentID);
    }

    const editRegistration = (paymentID) => {
        localStorage.setItem('isEdit', false);
        handleEditRegistration(paymentID);
    }

    const handleEditRegistration = (paymentID) => {
        let newRunners = [];
        runners.map((runner) => {
            if (runner.paymentID === paymentID) {

                runner.runner.map((data) => {
                    // console.log(data);

                    const obj = {
                        individualID: data.individualID,
                        paymentID: data.paymentID,
                        fullname: data.fullname,
                        gender: data.gender,
                        email: data.email,
                        bibName: data.bib_name,
                        dob: data.dob,
                        nationality: data.nationality,
                        mykad: data.mykad,
                        contact: data.phone,
                        emergencyName: data.emergency_name,
                        emergencyContact: data.emergency_contact,
                        medicalAttention: data.medical_attention,
                        category: data.race_cat,
                        categoryType: data.race_cat_type,
                        tshirt_type: data.tshirt_type,
                        tshirt_size: data.tshirt_size,
                        finisher: data.finisher_size,
                        racePackCollection: data.racePackCollection,
                        deliveryAddress: data.deliveryAddress,
                        deliveryPostcode: data.deliveryPostcode,
                        deliveryCity: data.deliveryCity,
                        deliveryState: data.deliveryState,
                        deliveryCountry: data.deliveryCountry,
                        datetime_posted: data.datetime_posted
                    };
                    newRunners.push(obj);
                });

                localStorage.setItem('editList', JSON.stringify(newRunners));

                var updateToken = authService.encryptUpdateToken(userID);
                // console.log(updateToken);
                navigate('/EditRegistration?updateToken=' + updateToken);

            }
        });
    }

    const handlePrint = (paymentID) => {
        window.open(process.env.REACT_APP_PUBLIC_URL + `/payment/download_chit.php?paymentID=${paymentID}`);
    }

    const checkRegistration = (e) => {
        // alert('Thank you for registering for KM2025! Due to overwhelming support, kindly take note that no changes to registration is allowed starting July 1st 2025 to facilitate the accuracy of BIB printing & documentation. Changes to Emergency Contact is allowed but only via support@marathonkuching.com. Please ENSURE that all information you enter is correct. For queries please email support@marathonkuching.com. Thank you for your understanding & attention to this matter.');
        // setLgShow(true);
    }


    return (
        <Container fluid="lg" className='wrapper'>
            <Tab.Container
                activeKey={key}
                onSelect={(k) => setKey(k)}
            >
                <Row>
                    <Col sm={3}>
                        <Nav variant="pills" className='flex-column' id="sidebar">
                            <Nav.Item>
                                <Nav.Link className="registerTab" onClick={goRegister}>Register Marathon</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="myRun">My Run</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="registration" onClick={checkRegistration}>Registration</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="profile">Profile</Nav.Link>
                            </Nav.Item>
                            {/* <Nav.Item>
                            <Nav.Link eventKey="history">History</Nav.Link>
                        </Nav.Item> */}
                        </Nav>
                    </Col>
                    <Col sm={9}>
                        <Tab.Content>

                            <Tab.Pane eventKey="myRun">
                                <Row>
                                    <Col sm={12} md={12} className="tab-container">
                                        {myBib && hasRun && (
                                            <Row className="m-4">
                                                <Col sm={12} md={6} >
                                                    <h1 className=''>
                                                        My Run
                                                        {/* &nbsp;
                                                    <Button className="red-button" onClick={handleRegistrationModalShow} >
                                                        <FontAwesomeIcon icon={faPen} />
                                                        &nbsp;
                                                        Edit Registration
                                                    </Button> */}
                                                    </h1>
                                                </Col>

                                                <Col sm={12} md={12} className='mb-4' >
                                                    <span className='intro'>
                                                        Click/tap the bib will flip the bib.
                                                        <br />
                                                        Bib number will be shown once the bib is ready and assigned to you.
                                                    </span>
                                                </Col>

                                                <div className="bib-container" >
                                                    <div className={flip ? 'bib-card flip' : 'bib-card'} style={{ height: `${cardHeight}px` }}>
                                                        <div className='front' ref={renderedRef} onClick={(e) => { setFlip(!flip) }}>
                                                            <Row className='bib-logo'>
                                                                <Col sm="12" md="12" className='d-flex' >
                                                                    <img src={process.env.PUBLIC_URL + '/images/kma-logo-white.png'} alt="" id="logo" />
                                                                    <div>
                                                                        <h5>Kuching Marathon 2026</h5>
                                                                        <h6>27 September 2026</h6>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <div className='white-background'>
                                                                <Row className="bib-name">
                                                                    <span>{runner.bib_no}</span>
                                                                </Row>
                                                            </div>
                                                            <Row className="bib-detail">
                                                                <Col sm={{ span: 12, order: 1 }} md={{ span: 6, order: 1 }} className="bib-detail-item left" >
                                                                    <span className='bib-label'>Bib Name</span>
                                                                    <span className="bib-input">{runner.bib_name}</span>
                                                                </Col>
                                                                <Col sm={{ span: 12, order: 3 }} md={{ span: 6, order: 2 }} className="bib-detail-item right" >
                                                                    {/* <span className='bib-label'>T-shirt Size</span> */}
                                                                    <span className='bib-label'>{runner.tshirt_type} Size</span>
                                                                    <span className="bib-input">{runner.tshirt_size}</span>
                                                                </Col>
                                                                <Col sm={{ span: 12, order: 2 }} md={{ span: 6, order: 3 }} className="bib-detail-item left" >
                                                                    <span className='bib-label'>Category</span>
                                                                    <span className="bib-input">
                                                                        {/* Men Veteran Full Marathon */}
                                                                        {runner.race_cat == '42KM' ? 'Full Marathon' : ''}
                                                                        {runner.race_cat == '21KM' ? 'Half Marathon' : ''}
                                                                        {runner.race_cat == '10KM' ? '10KM Run' : ''}
                                                                        {runner.race_cat == '5KM' ? '5KM Run' : ''}
                                                                        {profileInfo.gender == 'Male' ? ' Men ' : ' Women '}
                                                                        {runner.race_cat_type}
                                                                    </span>
                                                                </Col>
                                                                <Col sm={{ span: 12, order: 4 }} md={{ span: 6, order: 4 }} className="bib-detail-item right" >
                                                                    <span className='bib-label'>Finisher Size</span>
                                                                    <span className="bib-input">{runner.finisher_size}</span>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                        <div className="back" onClick={(e) => { setFlip(!flip) }}>
                                                            <Row className='bib-logo'>
                                                                <Col sm="12" md="12" className='d-flex' >
                                                                    <img src={process.env.PUBLIC_URL + '/images/kma-logo-white.png'} alt="" id="logo" />
                                                                    <div>
                                                                        <h5>Kuching Marathon 2026</h5>
                                                                        <h6>27 September 2026</h6>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <div className='white-background'>
                                                                <Row className="bib-emergency-detail">
                                                                    <Col sm="12" md="12" className="left" >
                                                                        <span className='bib-label'>Emergency Contact Person</span>
                                                                        <span className="bib-input">{runner.emergency_name}</span>
                                                                    </Col>
                                                                    <Col sm="12" md="12" className="left" >
                                                                        <span className='bib-label'>Emergency Contact Number</span>
                                                                        <span className="bib-input">{runner.emergency_contact}</span>
                                                                    </Col>
                                                                    <Col sm="12" md="12" className="left" >
                                                                        <span className='bib-label'>Medical Attention</span>
                                                                        <span className="bib-input">{runner.medical_attn}</span>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                            <Row className="bib-detail"></Row>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Row>
                                        )}
                                        {myBib && !hasRun && (
                                            <>
                                                <Row className="m-4">
                                                    <Col sm={12} md={12} className='mb-4 profileRegisterNow' >
                                                        <h5>Join Us</h5>
                                                        {/* <h1>21 September 2025</h1> */}
                                                        <h1>Year 2026</h1>
                                                        <h4>Padang Merdeka, Kuching, Sarawak</h4>
                                                        <Button className='red-button' onClick={goRegister}>Register Now</Button>
                                                    </Col>
                                                    <Col sm={12} md={12} style={{ textAlign: 'center' }}>
                                                        <img src={`${process.env.PUBLIC_URL}/images/profile-not-join.png`} alt="" style={{ width: '80%', margin: '0 auto' }} />
                                                    </Col>
                                                </Row>
                                            </>
                                        )}
                                        {!myBib && !hasRun && (
                                            <div className='myBib-loading-box d-flex align-items-center justify-content-center'>
                                                <h1>Loading &nbsp;</h1>
                                                <ThreeDots
                                                    height="80"
                                                    width="80"
                                                    radius="9"
                                                    color="#eb2127"
                                                    ariaLabel="three-dots-loading"
                                                    wrapperStyle={{}}
                                                    wrapperClassName=""
                                                    visible={true}
                                                />
                                            </div>
                                        )}

                                    </Col>
                                </Row>
                            </Tab.Pane>

                            <Tab.Pane eventKey="registration">
                                <Row>
                                    <Col sm={12} md={12} className="tab-container">

                                        <Row className="m-4">
                                            <Col sm={12} md={6} >
                                                <h1 className=''>
                                                    Registration
                                                </h1>
                                            </Col>
                                        </Row>

                                        <Row className="m-4">
                                            <Col sm={12} className="p-2">
                                                <div className='listTable-Section'>

                                                    {runners.length > 0 && runners.map((payment, index1) => (
                                                        <div className='mb-4' key={index1}>

                                                            <h3 className='table-date'>{payment.datetime}</h3>

                                                            <Accordion defaultActiveKey="0">
                                                                <Accordion.Item eventKey="0">
                                                                    <Accordion.Header>
                                                                        {payment.paymentID} - {payment.runner.length} Runner(s)
                                                                    </Accordion.Header>
                                                                    <Accordion.Body className="Cart-box">
                                                                        <ul className="Cart-list">
                                                                            <li>
                                                                                <Row className="cartItemList align-items-center">

                                                                                    {payment.runner.map((runner, index2) => (
                                                                                        <div key={index2}>

                                                                                            <Col sm={12} lg={12} className="itemDetail align-middle">
                                                                                                <Row>
                                                                                                    <Col sm={12} md={12} lg={12}>
                                                                                                        <h4>{runner.race_cat} {runner.gender === 'Male' ? 'Men' : 'Women'} {runner.race_cat_type}</h4>
                                                                                                    </Col>
                                                                                                    <Col sm={12} md={8} lg={8} className="mt-1">
                                                                                                        <span>{runner.fullname} ({runner.bib_name})</span>
                                                                                                    </Col>
                                                                                                    <Col sm={12} md={4} lg={4} className="itemQty regList mt-1">
                                                                                                        <span>{runner.mykad}</span>
                                                                                                    </Col>
                                                                                                    <Col sm={12} md={8} lg={8} className="mt-1">
                                                                                                        {/* <span>{runner.gender} | T-shirt : {runner.tshirt_size} {runner.finisher_size !== "" ? "| Finisher : " + runner.finisher_size : ""} </span> */}
                                                                                                        <span>{runner.gender} | {runner.tshirt_type} : {runner.tshirt_size} {runner.finisher_size !== "" ? "| Finisher : " + runner.finisher_size : ""} </span>
                                                                                                    </Col>
                                                                                                    <Col sm={6} md={4} lg={4} className="itemQty regList mt-1">
                                                                                                        <span>Bib No : {runner.bib_no !== "" ? runner.bib_no : "N/A"}</span>
                                                                                                    </Col>
                                                                                                    <Col sm={6} md={12} lg={12} className="itemAmount regList mt-1">
                                                                                                        <small>RM</small> <span>{runner.category_total}</span>
                                                                                                    </Col>
                                                                                                </Row>
                                                                                            </Col>
                                                                                            <Col sm={12} md={12} lg={12} className="">
                                                                                                {/* <Button variant="outline-secondary float-end" size="sm" onClick={() => {handleRegistrationModalShow(runner.individualID)}} ><FontAwesomeIcon icon={faTrash}/> Details</Button> */}
                                                                                                {runner.marathon_name === marathonName && (
                                                                                                    <>
                                                                                                        <Button variant="outline-secondary float-end" size="sm" onClick={() => { handlePrint(runner.paymentID) }} ><FontAwesomeIcon icon={faPrint} /> Download Confirmation</Button>
                                                                                                        <Button variant="outline-secondary float-end" size="sm" disabled={canEdit} onClick={() => { editRegistration(runner.paymentID) }} ><FontAwesomeIcon icon={faEdit} /> Edit</Button>
                                                                                                    </>
                                                                                                )}
                                                                                                <Button variant="outline-secondary float-end" size="sm" onClick={() => { registrationDetail(runner.paymentID) }} ><FontAwesomeIcon icon={faMagnifyingGlass} /> Details</Button>
                                                                                            </Col>

                                                                                        </div>
                                                                                    ))}

                                                                                </Row>
                                                                            </li>
                                                                        </ul>
                                                                    </Accordion.Body>
                                                                </Accordion.Item>
                                                            </Accordion>

                                                        </div>
                                                    ))}

                                                    {runners.length === 0 && (
                                                        <>
                                                            <Row className="">
                                                                <Col sm={12} md={12} className='mb-4 profileRegisterNow' >
                                                                    <h5>No past record</h5>
                                                                    <h1>Hope to see you soon!</h1>
                                                                    <Button className='red-button' onClick={goRegister}>Register Now</Button>
                                                                </Col>
                                                                <Col sm={12} md={12} style={{ textAlign: 'center' }}>
                                                                    <img src={`${process.env.PUBLIC_URL}/images/profile-not-join.png`} alt="" style={{ width: '80%', margin: '0 auto' }} />
                                                                </Col>
                                                            </Row>
                                                        </>
                                                    )}

                                                </div>
                                            </Col>
                                        </Row>

                                    </Col>
                                </Row>
                            </Tab.Pane>

                            <Tab.Pane eventKey="profile">
                                <Row>
                                    <Col sm={12} md={12} className="tab-container">

                                        <Formik
                                            enableReinitialize
                                            initialValues={profileInfo}
                                            validationSchema={SignUpSchema1}
                                            onSubmit={submitForm1}
                                        >
                                            {({ values, handleChange, handleSubmit, errors, touched, handleBlur, isValid, dirty }) => (
                                                <Form className="p-3" noValidate onSubmit={handleSubmit}>

                                                    <Row className='justify-content-md-center mb-4 text-center'>
                                                        {/* <div className='profile-pic-div align-items-end mb-3'>
                                                        <Image src={`${process.env.PUBLIC_URL}/images/user.png`} className='profile-pic' roundedCircle />
                                                        <Button className="profile-pic-btn red-button" ><FontAwesomeIcon icon={faPen} /></Button>
                                                    </div> */}
                                                        <span className='profile-individualID'>{values.individualID}</span>
                                                    </Row>

                                                    <Form.Group as={Row} className="mb-3" controlId="mykadSection" style={{ color: "#fff" }}>
                                                        <Form.Label column sm="3">
                                                            IC / Passport
                                                        </Form.Label>
                                                        <Col sm="9">
                                                            <Form.Control
                                                                name={`mykad`}
                                                                type="text"
                                                                onChange={handleChange}
                                                                value={values.mykad}
                                                                style={{ color: "#fff" }}
                                                                plaintext
                                                                readOnly />
                                                            <Form.Text className="small-text">
                                                                Please contact admin to update IC / Passport
                                                            </Form.Text>
                                                        </Col>
                                                    </Form.Group>

                                                    <Form.Group as={Row} className="mb-3" controlId="emailSection">
                                                        <Form.Label column sm="3" style={{ color: "#fff" }}>
                                                            Email
                                                        </Form.Label>
                                                        <Col sm="9">
                                                            <Row>
                                                                <Col sm="9" style={{ color: "#fff" }}>
                                                                    <Form.Control
                                                                        required
                                                                        name={`email`}
                                                                        type="text"
                                                                        placeholder="email@example.com"
                                                                        onChange={(e) => {
                                                                            handleChange(e);
                                                                            handleEmail(e);
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                        value={values.email}
                                                                        isValid={touched.email && !errors.email}
                                                                        isInvalid={!!errors.email}
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                                                                </Col>
                                                                <Col sm="3">
                                                                    <Button variant="success" onClick={handleVerifyEmailModalShow} disabled={emailVerified === 1 ? false : true} >
                                                                        Verify
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                            {emailVerified == 1 && (
                                                                <Form.Text className="small-text text-danger">
                                                                    Please verify your email if you want to update your email
                                                                </Form.Text>
                                                            )}
                                                            {emailVerified == 2 && (
                                                                <Form.Text className="small-text text-success">
                                                                    Email has been verified
                                                                </Form.Text>
                                                            )}
                                                        </Col>
                                                    </Form.Group>

                                                    <Form.Group as={Row} className="mb-3">
                                                        <Form.Label column sm="3" style={{ color: "#fff" }}>
                                                            Password
                                                        </Form.Label>
                                                        <Col sm="9">
                                                            <div className='d-flex'>
                                                                <Button variant="warning" onClick={handlePasswordModalShow}>
                                                                    Change Password
                                                                </Button>

                                                                <TailSpin
                                                                    height="32"
                                                                    width="32"
                                                                    color="#ccc"
                                                                    ariaLabel="tail-spin-loading"
                                                                    radius="2"
                                                                    wrapperStyle={{ marginLeft: "10px" }}
                                                                    wrapperClass="loader"
                                                                    visible={passwordLoading}
                                                                />
                                                            </div>

                                                            {passwordErr && (
                                                                <Col md={12} xs={12} className="mt-2">
                                                                    <Alert variant="danger" onClose={() => setPasswordErr(false)} dismissible>
                                                                        {passwordErrMessage}
                                                                    </Alert>
                                                                </Col>
                                                            )}
                                                            {passwordMessage != '' && (
                                                                <Col md={12} xs={12} className="mt-2">
                                                                    <Alert variant="success" onClose={() => setPasswordMessage('')} dismissible>
                                                                        {passwordMessage}
                                                                    </Alert>
                                                                </Col>
                                                            )}

                                                        </Col>
                                                    </Form.Group>

                                                    <br /><hr style={{ color: "#fff" }} /><br /><br /><br />

                                                    <Row className="mb-3">
                                                        <Form.Group className="mb-2" as={Col} md="6" controlId="validationCustom01">
                                                            <FloatingLabel controlId="validationCustom01" label="First name">
                                                                <Form.Control
                                                                    required
                                                                    name={`firstname`}
                                                                    type="text"
                                                                    placeholder="First name"
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values.firstname}
                                                                    isValid={touched.firstname && !errors.firstname}
                                                                    isInvalid={!!errors.firstname}
                                                                />
                                                                <Form.Control.Feedback type="invalid">{errors.firstname}</Form.Control.Feedback>
                                                            </FloatingLabel>
                                                        </Form.Group>
                                                        <Form.Group className="mb-2" as={Col} md="6" controlId="validationCustom02">
                                                            <FloatingLabel controlId="validationCustom02" label="Last name">
                                                                <Form.Control
                                                                    required
                                                                    name={`lastname`}
                                                                    type="text"
                                                                    placeholder="Last name"
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values.lastname}
                                                                    isValid={touched.lastname && !errors.lastname}
                                                                    isInvalid={!!errors.lastname}
                                                                />
                                                                <Form.Control.Feedback type="invalid">{errors.lastname}</Form.Control.Feedback>
                                                            </FloatingLabel>
                                                        </Form.Group>
                                                    </Row>

                                                    <Row className="mb-3 phoneInputDiv">
                                                        <Form.Group className="mb-2" as={Col} md="3" controlId="validationCustom05">
                                                            <FloatingLabel controlId="validationCustom05" label="Gender">
                                                                <Form.Select
                                                                    aria-label="Default select example"
                                                                    name={`gender`}
                                                                    onChange={handleChange}
                                                                    value={values.gender}
                                                                    isValid={touched.gender && !errors.gender}
                                                                    isInvalid={!!errors.gender}
                                                                >
                                                                    <option style={{ background: '#fff', color: '#777' }} key="" value="">Gender</option>
                                                                    <option style={{ background: '#fff', color: '#777' }} key="Male" value="Male">Male</option>
                                                                    <option style={{ background: '#fff', color: '#777' }} key="Female" value="Female">Female</option>
                                                                </Form.Select>
                                                                <Form.Control.Feedback type="invalid">{errors.gender}</Form.Control.Feedback>
                                                            </FloatingLabel>
                                                        </Form.Group>
                                                        <Form.Group className="mb-2" as={Col} md="4" controlId="validationCustom06">
                                                            <FloatingLabel controlId="validationCustom06" label="Date of Birth">
                                                                <Form.Control
                                                                    required
                                                                    name={`dob`}
                                                                    type="date"
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values.dob}
                                                                    isValid={touched && touched.dob && !errors.dob}
                                                                    isInvalid={!!errors.dob}
                                                                />
                                                                <Form.Control.Feedback type="invalid">{errors.dob}</Form.Control.Feedback>
                                                            </FloatingLabel>
                                                        </Form.Group>
                                                        <Form.Group as={Col} md="5" className="mb-2 phone-float-input" controlId="validationCustom07">
                                                            <FloatingLabel controlId="validationCustom07" label="Contact No">
                                                                <PhoneInput
                                                                    id="select-input"
                                                                    name={`.contact`}
                                                                    className={
                                                                        "form-control " +
                                                                        (!!errors.contact ? "is-invalid" : "") + " " +
                                                                        (touched && touched.contact && !errors.contact ? "is-valid" : "")
                                                                    }
                                                                    country={'my'}
                                                                    inputProps={{
                                                                        name: `contact`,
                                                                    }}
                                                                    onBlur={handleBlur}
                                                                    onChange={(phoneNumber, country, e) => { handleChange(e) }}
                                                                    value={values.contact}
                                                                />
                                                                <Form.Control isInvalid={!!errors.contact} hidden />
                                                                <Form.Control.Feedback type="invalid">{errors.contact}</Form.Control.Feedback>
                                                            </FloatingLabel>
                                                        </Form.Group>
                                                    </Row>

                                                    <Row className="mb-3">
                                                        <Form.Group as={Col} md="6" className="mb-3" controlId="validationCustom08">
                                                            <FloatingLabel controlId="validationCustom08" label="Country">
                                                                <Form.Select
                                                                    aria-label="Default select example"
                                                                    name="country"
                                                                    onChange={handleChange}
                                                                    isValid={touched.country && !errors.country}
                                                                    isInvalid={!!errors.country}
                                                                    value={values.country}
                                                                >
                                                                    <option key="" value="">Select a country</option>
                                                                    {
                                                                        countryList.map(data => (
                                                                            <option key={data.country} value={data.country}>{data.country}</option>
                                                                        ))
                                                                    }
                                                                </Form.Select>
                                                                <Form.Control.Feedback type="invalid">{errors.country}</Form.Control.Feedback>
                                                            </FloatingLabel>
                                                        </Form.Group>
                                                        <Form.Group className="mb-2" as={Col} md="6" controlId="validationCustom09">
                                                            <FloatingLabel controlId="validationCustom09" label="Nationality">
                                                                <Form.Select
                                                                    aria-label="Default select example"
                                                                    name={`nationality`}
                                                                    onChange={handleChange}
                                                                    value={values.nationality}
                                                                    isValid={touched && touched.nationality && !errors.nationality}
                                                                    isInvalid={!!errors.nationality}
                                                                >
                                                                    <option style={{ background: '#fff', color: '#777' }} key="" value="">Nationality</option>
                                                                    {
                                                                        countryList.map(data => (
                                                                            <option style={{ background: '#fff', color: '#777' }} key={data.country} value={data.country}>{data.country}</option>
                                                                        ))
                                                                    }
                                                                </Form.Select>
                                                                <Form.Control.Feedback type="invalid">{errors.nationality}</Form.Control.Feedback>
                                                            </FloatingLabel>
                                                        </Form.Group>
                                                    </Row>

                                                    <Row className="mb-3">
                                                        <Form.Group className="mb-2" as={Col} md="6" controlId="validationCustom10">
                                                            <FloatingLabel controlId="validationCustom10" label="State">
                                                                <Form.Control
                                                                    required
                                                                    name={`state`}
                                                                    type="text"
                                                                    placeholder="State"
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values.state}
                                                                    isValid={touched.state && !errors.state}
                                                                    isInvalid={!!errors.state}
                                                                />
                                                                <Form.Control.Feedback type="invalid">{errors.state}</Form.Control.Feedback>
                                                            </FloatingLabel>
                                                        </Form.Group>
                                                        <Form.Group className="mb-2" as={Col} md="6" controlId="validationCustom11">
                                                            <FloatingLabel controlId="validationCustom11" label="Postcode">
                                                                <Form.Control
                                                                    required
                                                                    name={`postcode`}
                                                                    type="text"
                                                                    placeholder="Postcode"
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values.postcode}
                                                                    isValid={touched.postcode && !errors.postcode}
                                                                    isInvalid={!!errors.postcode}
                                                                />
                                                                <Form.Control.Feedback type="invalid">{errors.postcode}</Form.Control.Feedback>
                                                            </FloatingLabel>
                                                        </Form.Group>
                                                    </Row>

                                                    <Row className="mb-3">
                                                        <Form.Group className="mb-2" as={Col} md="12" controlId="validationCustom12">
                                                            <FloatingLabel controlId="validationCustom12" label="Address">
                                                                <Form.Control
                                                                    required
                                                                    as="textarea"
                                                                    style={{ height: '100px' }}
                                                                    name={`address`}
                                                                    type="text"
                                                                    placeholder="Address"
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values.address}
                                                                    isValid={touched.address && !errors.address}
                                                                    isInvalid={!!errors.address}
                                                                />
                                                                <Form.Control.Feedback type="invalid">{errors.address}</Form.Control.Feedback>
                                                            </FloatingLabel>
                                                        </Form.Group>
                                                    </Row>

                                                    {updateProfileMessage !== '' && (
                                                        <Row className="justify-content-md-center mb-3">
                                                            <Col md={12} sm={12}>
                                                                <Alert variant="success" onClick={(e) => { updateProfileMessage(''); }} dismissible>
                                                                    {updateProfileMessage}
                                                                </Alert>
                                                            </Col>
                                                        </Row>
                                                    )}
                                                    {updateProfileErrMessage !== '' && (
                                                        <Row className="justify-content-md-center mb-3">
                                                            <Col md={12} sm={12}>
                                                                <Alert variant="danger" onClick={(e) => { updateProfileErrMessage(''); }} dismissible>
                                                                    {updateProfileErrMessage}
                                                                </Alert>
                                                            </Col>
                                                        </Row>
                                                    )}

                                                    <Row className="justify-content-md-center mb-3">
                                                        <Col md={6} sm={12}>
                                                            <Button type="submit" className="red-button form-control d-flex justify-content-center">
                                                                Save &nbsp;
                                                                <TailSpin
                                                                    height="24"
                                                                    width="24"
                                                                    color="#777"
                                                                    ariaLabel="tail-spin-loading"
                                                                    radius="2"
                                                                    wrapperStyle={{}}
                                                                    wrapperClass="loader"
                                                                    visible={updateProfilLoading}
                                                                />
                                                            </Button>
                                                        </Col>
                                                    </Row>

                                                </Form>
                                            )}
                                        </Formik>

                                    </Col>
                                </Row>
                            </Tab.Pane>

                            <Tab.Pane eventKey="history">
                                <Row>
                                    <Col sm={12} md={12} className="tab-container">

                                    </Col>
                                </Row>
                            </Tab.Pane>

                        </Tab.Content>
                    </Col>
                </Row>
            </Tab.Container>

            <VerifyEmailModal
                email={email}
                sendOTP={sendOTP}
                verifyEmailModal={verifyEmailModal}
                handleVerifyEmailModalHide={handleVerifyEmailModalHide}
                handleSubmitVerifyEmail={handleSubmitVerifyEmail}
                verifyEmailLoading={verifyEmailLoading}
                verifyEmailMessage={verifyEmailMessage}
                verifyEmailErr={verifyEmailErr}
                verifyEmailErrMessage={verifyEmailErrMessage}
            />

            <UpdatePasswordModal
                updatePasswordModal={updatePasswordModal}
                handlePasswordModalHide={handlePasswordModalHide}
                handleSubmitResetPassword={handleSubmitResetPassword}
                passwordLoading={passwordLoading}
            />

            <NoticeModal
                lgShow={lgShow}
                setLgShow={setLgShow}
            />

            {/* <UpdateRegistrationModal
                runnerID={runnerID}
                authToken={authToken}
                updateRegistrationModal={updateRegistrationModal}
                handleRegistrationModalHide={handleRegistrationModalHide}
            /> */}



        </Container>

    );
}

export default Profile;